import OrderSummary from './OrderSummary.component';

export default OrderSummary;
